const crypto = require('crypto');
// 小程序端加密工具类 服务器地址http://192.168.69.55:5001/  文档：http://192.168.69.55:5001/apitest/api-doc.html
class ClientEncryptor {
	constructor(appKey) {
		this.appKey = appKey;
	}

	/**
	 * 生成安全请求参数
	 */
	generateSecureRequest(method, params) {
		const timestamp = Date.now();
		const nonce = this.generateNonce(16);

		// 在参数中添加时间戳和随机数
		const requestParams = {
			...params,
			timestamp,
			nonce
		};

		// 加密参数
		const encryptedData = this.encryptAES(JSON.stringify(requestParams), this.appKey);

		// 构建签名数据
		const signData = {
			Method: method,
			Params: encryptedData,
			Timestamp: timestamp,
			Nonce: nonce
		};

		// 生成签名
		const sign = this.generateSignature(signData, this.appKey);

		return {
			Method: method,
			Params: encryptedData,
			Sign: sign,
			Timestamp: timestamp,
			Nonce: nonce
		};
	}

	/**
	 * 生成随机数
	 */
	generateNonce(length) {
		const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';
		for (let i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	}

	/**
	 * 生成签名
	 */
	generateSignature(data, key) {
		// 按字段名排序并序列化
		const sortedKeys = Object.keys(data).sort();
		const signString = sortedKeys
			.map(k => `${k}=${typeof data[k] === 'object' ? JSON.stringify(data[k]) : data[k]}`)
			.join('&');

		// 使用HMAC-SHA256生成签名
		const hmac = crypto.createHmac('sha256', key);
		hmac.update(signString);
		return hmac.digest('hex');
	}

	/**
	 * AES-GCM 加密函数（与服务器端保持一致）
	 */
	encryptAES(data, key) {
		try {
			// 确保数据是字符串
			if (typeof data !== 'string') data = JSON.stringify(data);

			// 解码密钥
			const keyBuffer = Buffer.from(key, 'base64');

			// console.log(crypto.randomBytes, 'data2')
			// 生成随机 IV (初始化向量)
			const iv = crypto.randomBytes(12);

			// console.log(iv, 'data3')
			// 创建加密器
			const cipher = crypto.createCipheriv('aes-256-gcm', keyBuffer, iv);

			// 加密数据
			let encrypted = cipher.update(data, 'utf8', 'base64');
			encrypted += cipher.final('base64');

			// 获取认证标签
			const authTag = cipher.getAuthTag().toString('base64');

			// 组合加密结果: 版本|IV|认证标签|加密数据
			return `v1|${iv.toString('base64')}|${authTag}|${encrypted}`;
		} catch (error) {
			console.error('加密失败:', error);
			throw new Error('加密过程发生错误');
		}
	}

	/**
	 * AES-GCM 解密函数
	 * @param {string} encryptedData - 加密数据，格式为: 版本|IV|认证标签|加密数据
	 * @param {string} key - Base64 编码的密钥
	 * @returns {string|object} - 解密后的数据
	 */
	decryptAES(encryptedData, ) {
		let key = this.appKey;
		try {
			// 参数验证
			if (!encryptedData) {
				throw new Error('缺少必要参数');
			}
			if (!key) key = this.app.config.encryptkey;

			// 解码密钥
			const keyBuffer = Buffer.from(key, 'base64');

			// 解析加密数据
			const parts = encryptedData.split('|');

			if (parts.length !== 4) {
				throw new Error('无效的加密数据格式，应为"版本|IV|认证标签|加密数据"');
			}

			const [version, ivBase64, authTagBase64, encrypted] = parts;

			// 验证版本
			if (version !== 'v1') {
				throw new Error(`不支持的加密版本: ${version}`);
			}

			// 解码 IV 和认证标签
			const iv = Buffer.from(ivBase64, 'base64');
			const authTag = Buffer.from(authTagBase64, 'base64');

			// 创建 AES-GCM 解密器
			const decipher = crypto.createDecipheriv('aes-256-gcm', keyBuffer, iv);

			// 设置认证标签
			decipher.setAuthTag(authTag);

			// 解密数据
			let decrypted = decipher.update(encrypted, 'base64', 'utf8');
			decrypted += decipher.final('utf8');

			// 尝试解析 JSON 数据
			try {
				return JSON.parse(decrypted);
			} catch {
				// 如果不是 JSON，返回原始字符串
				return decrypted;
			}
		} catch (error) {
			console.error('解密失败:', error);
			throw new Error('解密过程发生错误');
		}
	}
}





// 小程序端使用示例
export const encryptor = new ClientEncryptor('J73CUuqVQElvxwXvbF+yucntcMVBjXNXXEJqSxAktuA=');


// // 准备请求参数
// const method = 'api.system.openminprogram';
// const params = {
// 	userid: 0
// };

// // 生成安全请求
// const secureRequest = encryptor.generateSecureRequest(method, params);

// // 发送请求
// wx.request({
// 	url: 'http://192.168.69.55:5001/',
// 	method: 'POST',
// 	data: secureRequest,
// 	success: (res) => {
// 		console.log('请求成功:', res.data);
// 	},
// 	fail: (error) => {
// 		console.error('请求失败:', error);
// 	}
// });